module.exports = __webpack_public_path__ + "img/Borlaug_CX.e7680fc5.png";